{
  "title": "Фоновые задачи",
  "stats": {
    "total": "Всего",
    "active": "Активные",
    "processed": "Обработанные",
    "tasksInQueue": "Задач в очереди",
    "retried": "Повторяются"
  },
  "states": {
    "all": "Все",
    "active": "Активные",
    "success": "Успешные",
    "failed": "С ошибками"
  },
  "workers": {
    "title": "Обработчики",
    "name": "Имя",
    "status": "Состояние",
    "processes": "Процессы",
    "pending": "В ожидании",
    "started": "Активные",
    "processed": "Обработанные",
    "success": "Успешные",
    "failure": "С ошибками",
    "retry": "Повторяются",
    "clearQueue": "Очистить очередь",
    "killActiveTasks": "Завершить активные задачи",
    "queues": "Очереди",
    "all": "Всего"
  },
  "tasks": {
    "title": "Задачи",
    "name": "Имя",
    "state": "Состояние",
    "received": "Время получения",
    "started": "Время запуска",
    "runtime": "Длительность",
    "killTask": "Завершить задачу"
  },
  "queues": {
    "name": "Имя",
    "state": "Состояние",
    "ready": "Готовые",
    "unacknowledged": "В обработке",
    "total": "Всего",
    "clearQueue": "Очистить очередь"
  }
}